"use strict";

/**
 * Druck-Modul-Events.
 * @enum {string}
 */
gc.gis.module.GCPlotEvent = {
	/**
	 * 
	 */
	LAYOUTS_UPDATED: 'update:layouts',
	/**
	 *
	 */
	LAYOUT_CHANGED: 'change:layout',
	/**
	 *
	 */
	SCALE_CHANGED: 'change:scale',
	/**
	 *
	 */
	RESOLUTION_CHANGED: 'change:resolution'
};

/**
 * @classdesc
 * Druck-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.requests.plotLayoutUrl Request-URL zur Abfrage verfügbarer Druckvorlagen
 * @param {string} options.requests.plotUrl Request-URL zur Ausführung des Drucks
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}] Karten-Instanz
 * @param {string} [options.label='Drucken'] Label
 *
 * @param {boolean} [options.enableEditTitle=false] gibt an, ob der Titel durch den Nutzer editierbar ist
 * @param {boolean} [options.enableEditDescription=false] gibt an, ob die Beschreibung durch den Nutzer editierbar ist
 * @param {boolean} [options.enableShowLegend=false] gibt an, ob die Ausgabe der Legende durch den Nutzer de-/aktivierbar ist
 * @param {boolean} [options.enableShowAuthor=false] gibt an, ob die Ausgabe des Bearbeiters durch den Nutzer de-/aktivierbar ist
 * @param {boolean} [options.enableShowNorthArrow=false] gibt an, ob die Ausgabe des Nordpfeils durch den Nutzer de-/aktivierbar ist
 * @param {boolean} [options.enableShowDate=false] gibt an, ob die Ausgabe des Datums durch den Nutzer de-/aktivierbar ist
 * @param {boolean} [options.enableShowScale=false] gibt an, ob die Ausgabe des Maßstabs durch den Nutzer de-/aktivierbar ist
 * @param {boolean} [options.enableShowScalebar=false] gibt an, ob die Ausgabe des Maßstabbalkens durch den Nutzer de-/aktivierbar ist
 * @param {boolean} [options.enableShowCadastral=false] gibt an, ob die Ausgabe von Gemarkung/Flur durch den Nutzer de-/aktivierbar ist
 */
gc.gis.module.GCPlot = function( options )
{
	gc.gis.module.GCAbstractModule.call( this, options );

	this._DEFAULT_SCALES = [
		{
			label: '100',
			value: 100
		},
		{
			label: '250',
			value: 250
		},
		{
			label: '500',
			value: 500
		},
		{
			label: '1.000',
			value: 1000
		},
		{
			label: '2.500',
			value: 2500
		},
		{
			label: '5.000',
			value: 5000
		},
		{
			label: '10.000',
			value: 10000
		},
		{
			label: '25.000',
			value: 25000
		},
		{
			label: '50.000',
			value: 50000
		},
		{
			label: '100.000',
			value: 100000
		}
	];

	this.options       = options;
	this.map           = options.map || gc.gis.iface.map;
	this.label         = options.label || 'Drucken';

	this.enableEditTitle = gc.gis.GCUtil.parseBool(options.enableEditTitle, false);
	this.enableEditDescription = gc.gis.GCUtil.parseBool(options.enableEditDescription, false);
	this.enableShowLegend = gc.gis.GCUtil.parseBool(options.enableShowLegend, false);
	this.enableShowAuthor = gc.gis.GCUtil.parseBool(options.enableShowAuthor, false);
	this.enableShowNorthArrow = gc.gis.GCUtil.parseBool(options.enableShowNorthArrow, false);
	this.enableShowDate = gc.gis.GCUtil.parseBool(options.enableShowDate, false);
	this.enableShowScale = gc.gis.GCUtil.parseBool(options.enableShowScale, false);
	this.enableShowScalebar = gc.gis.GCUtil.parseBool(options.enableShowScalebar, false);
	this.enableShowCadastral = gc.gis.GCUtil.parseBool(options.enableShowCadastral, false);

	this._available_resolutions = [
		{
			label: '72dpi',
			value: 72
		},
		{
			label: '150dpi',
			value: 150
		},
		{
			label: '300dpi',
			value: 300
		}
	];
	this._available_layouts = [{}];
	this._available_scales = this._DEFAULT_SCALES;

	this.current_resolution  = this._available_resolutions[0].value;
	this.current_scale       = this._available_scales[0].value;
    this.current_layout = null;

	this.mask = new gc.gis.module.GCPlot.OLPaperMask({
		module: this,
		map: this.map
	});

	this._initEvents();
	this._render();
	this.updateLayouts();

	// Sidebar-Panel
	this.launcher = {
		label: this.label,
		icon: 'glyphicon glyphicon-print',
		content: new gc.gis.ui.GCSidebarContent({
            label:   this.label,
            'parent': null,
            element: this.getElement()
        })
	};
	gc.gis.iface.ui.sidebar.addLauncher( this.launcher );
};
gc.gis.module.GCPlot.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 * Initialisiert Events.
 *
 * @protected
 * @method
 */
gc.gis.module.GCPlot.prototype._initEvents = function()
{
	var self = this;

	this.on( gc.gis.module.GCPlotEvent.LAYOUT_CHANGED, this, function( evt ) {
		if( self.mask.isActive() )
		{
			if( !self.mask.isWithinBounds() )
			{
				self.zoomToMask();
			}
		}
	});
	this.on( gc.gis.module.GCPlotEvent.SCALE_CHANGED, this, function( evt ) {
		if( self.mask.isActive() )
		{
			if( !self.mask.isWithinBounds() )
			{
				self.zoomToMask();
			}
		}
	});

	gc.gis.iface.ui.sidebar.on( gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, this, function( evt ) {
		if( evt.newValue === self.launcher.content )
		{
			self.mask.setActive( true );
		}
		else if( evt.oldValue === self.launcher.content )
		{
			self.mask.setActive( false );
		}
	});
};

/**
 * @return {jQuery}
 */
gc.gis.module.GCPlot.prototype.getElement = function()
{
	return this.element_panel.getElement();
};

/**
 * @return {jQuery}
 */
gc.gis.module.GCPlot.prototype._render = function()
{
	this.element_panel = new gc.gis.module.GCPlot.Panel({
		module: this
	});
	return this.element_panel_list;
};

/**
 * Startet einen Ajax-Request, der die verfügbaren Drucklayouts aktualisiert.
 *
 * @public
 * @method
 */
gc.gis.module.GCPlot.prototype.updateLayouts = function()
{
	var self = this;
	
	gc.gis.iface.request.ajax({
		label: 'Aktualisiere verfügbare Drucklayouts ... ',
		context: this,
		url: this.options.requests.plotLayoutUrl,
		dataType: gc.gis.util.GCRequestManagerDataType.JSON,
		success: function( data ) {
			self._available_layouts = data.results;
			self._fireEvent( gc.gis.module.GCPlotEvent.LAYOUTS_UPDATED, {
				layouts: self._available_layouts
			});

			if( self._available_layouts.length > 0 )
			{
				self.setLayout(self._available_layouts[0]);
			}
		}
	});
};

/**
 * Startet den Druck-Request.
 *
 * @public
 * @method
 *
 * @param {Object<string,*>} params Druck-Parameter
 */
gc.gis.module.GCPlot.prototype.executePlotRequest = function(params)
{
	//gc.gis.iface.request.download(this.options.requests.plotUrl, params);
	gc.gis.iface.request.download(this.options.requests.plotUrl, {params: JSON.stringify(params)});
};

/**
 * Zoomt auf den Extent der Maskengeometrie.
 *
 * @public
 * @method
 */
gc.gis.module.GCPlot.prototype.zoomToMask = function()
{
    this.map.fitExtent(this.mask.getExtent(), {
        constrain_resolution: true
    });
};

/**
 * Liefert den Tracking-Layer zur Papier-Maske.
 *
 * @public
 * @method
 * @return {gc.gis.layer.OLTrackingLayer}
 */
gc.gis.module.GCPlot.prototype.getMaskTrackingLayer = function()
{
	return this.mask.getTrackingLayer();
};

/**
 * Liefert den Extent der Maskengeometrie.
 *
 * @public
 * @method
 * @return {gc.gis.map.GCMapExtent}
 */
gc.gis.module.GCPlot.prototype.getMaskExtent = function()
{
	return this.mask.getExtent();
};

/**
 * Liefert die Geometrie der Maske.
 *
 * @public
 * @method
 * @return {gc.gis.geom.GCGeometry}
 */
gc.gis.module.GCPlot.prototype.getMaskGeometry = function()
{
	return this.mask.getGeometry();
};

/**
 * Gibt die verfügbaren Drucklayouts zurück.
 *
 * @public
 * @method
 *
 * @return {Array<Object>}
 */
gc.gis.module.GCPlot.prototype.getAvailableLayouts = function()
{
	return this._available_layouts;
};

/**
 * Gibt das aktuell ausgewählte Drucklayout zurück.
 *
 * @public
 * @method
 *
 * @return {Object}
 */
gc.gis.module.GCPlot.prototype.getLayout = function()
{
	return this.current_layout;
};

/**
 * Setzt das aktuelle Drucklayout
 *
 * @public
 * @method
 *
 * @param {Object} layout
 */
gc.gis.module.GCPlot.prototype.setLayout = function(layout)
{
	this.current_layout = layout;

	if (layout.scales && layout.scales.length > 0) {
		this._available_scales = layout.scales;
		this._available_scales.sort(function(a, b){
			return a.value - b.value;
		});
	}
	else {
		this._available_scales = this._DEFAULT_SCALES;
	}

	this._fireEvent( gc.gis.module.GCPlotEvent.LAYOUT_CHANGED, {
		layout: layout
	});
};

/**
 * Setzt das aktuelle Drucklayout anhand dessen ID.
 *
 * @public
 * @method
 *
 * @param {String} layout_id
 */
gc.gis.module.GCPlot.prototype.setLayoutByID = function (layout_id) {
	for (var i = 0; i < this._available_layouts.length; i++)
	{
		if (this._available_layouts[i].id && this._available_layouts[i].id == layout_id)
		{
			this.setLayout(this._available_layouts[i]);
			return;
		}
	}
};

/**
 * Gibt die Liste der aktuell verfügbaren Druckauflösungen zurück.
 *
 * @public
 * @method
 *
 * @return {Array<Object>}
 */
gc.gis.module.GCPlot.prototype.getAvailableResolutions = function()
{
	return this._available_resolutions;
};

/**
 * Gibt die aktuelle Druckauflösung zurück.
 *
 * @public
 * @method
 *
 * return {number}
 */
gc.gis.module.GCPlot.prototype.getResolution = function()
{
	return this.current_resolution;
};

/**
 * Setzt die aktuelle Druckauflösung.
 *
 * @public
 * @method
 *
 * @param {number} resolution
 */
gc.gis.module.GCPlot.prototype.setResolution = function( resolution )
{
	this.current_resolution = resolution;
	this._fireEvent( gc.gis.module.GCPlotEvent.RESOLUTION_CHANGED, {
		resolution: resolution
	});
};

/**
 * Gibt die aktuell verfügbaren Maßstäbe zurück.
 *
 * @public
 * @method
 *
 * @return {Array<Object>}
 */
gc.gis.module.GCPlot.prototype.getAvailableScales = function()
{
	return this._available_scales;
};

/**
 * Gibt den aktuell gewählten Maßstab zurück.
 *
 * @public
 * @method
 *
 * @return {number}
 */
gc.gis.module.GCPlot.prototype.getScale = function()
{
	return this.current_scale;
};

/**
 * Setzt den aktuellen Maßstab.
 *
 * @public
 * @method
 *
 * @param {number} scale
 */
gc.gis.module.GCPlot.prototype.setScale = function( scale )
{
	this.current_scale = scale;
	this._fireEvent( gc.gis.module.GCPlotEvent.SCALE_CHANGED, {
		scale: scale
	});
};
